var map = {
	"./analytics.js": "5a75",
	"./app.js": "2a3e",
	"./auth.js": "11c0",
	"./coupon.js": "f046",
	"./dashboard.js": "d959",
	"./inventory.js": "42d8",
	"./member.js": "5e44",
	"./merchant.js": "bd45",
	"./order.js": "2d14",
	"./prepaid.js": "2663",
	"./product.js": "1665",
	"./staff.js": "f917"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfa9";